'use strict'

var locator = require('../locate/mention')

module.exports = mention

mention.locator = locator
mention.notInLink = true

const RE_MENTION = /\[(@.*?)\](.*?)/;
const RE_PLUS_MENTION = /\[(\+.*?)\](.*?)/;

// Tokenise a mention.
function mention(eat, value, silent) {
  if (value.charAt(0) !== '[') {
    return
  }

  if (!RE_MENTION.test(value) && !RE_PLUS_MENTION.test(value) ) {
    return
  }

  /* istanbul ignore if - Maybe used by plugins? */
  if (silent) {
    return true
  }

  const mentionBlock = value.substring(value.indexOf('['), value.indexOf(']') + 1)
  const mentionText = value.substring(value.indexOf('[') + 1, value.indexOf(']'))

  return eat(mentionBlock)({
    type: 'link',
    title: null,
    url: "#mention",
    children: [{
      type: 'text',
      value: mentionText
    }]
  })
}
